import classNames from 'classnames';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { NewScarcityIcon } from '@sorare/core/src/atoms/icons/ScarcityIcon';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';

import { MyCardsRaritySwitcherBox } from './ui';

type Props = {
  countByRarity: {
    [Rarity.common]?: number;
    [Rarity.limited]?: number;
    [Rarity.rare]?: number;
    [Rarity.super_rare]?: number;
    [Rarity.unique]?: number;
  };
  rarityPath: (rarity: Rarity) => string;
  type: Rarity;
  onClick?: (rarity: Rarity) => void;
};

export const CardOrCollectionRaritySwitcher = ({
  countByRarity,
  rarityPath,
  type,
  onClick,
}: Props) => {
  return (
    <Horizontal>
      {Object.entries(countByRarity)
        .filter(([, value]) => !!value)
        .map(([key, value]) => (
          <MyCardsRaritySwitcherBox
            key={key}
            to={rarityPath(key as keyof typeof countByRarity)}
            className={classNames({
              active: type === key,
            })}
            onClick={
              onClick
                ? () => {
                    onClick(key as keyof typeof countByRarity);
                  }
                : undefined
            }
          >
            <NewScarcityIcon
              rarity={key as keyof typeof countByRarity}
              size={5}
            />
            <LabelM bold>{value}</LabelM>
          </MyCardsRaritySwitcherBox>
        ))}
    </Horizontal>
  );
};
